import { Config, ConfigItem, webHomeConfig } from '../types';
export interface ConfigGetters {
  getBanners: (config: webHomeConfig, isMobile: boolean) => any | null;
  getHeroes: (config: webHomeConfig, isMobile: boolean) => any | null;
  getKatherina: (config: webHomeConfig) => any | null;
  getKatherinaTopBar: (config: webHomeConfig) => any | null;
  getButtonText: (config: ConfigItem) => any | null;
  getSocial:(config: Config) => any | null;
}
function getDeskBanners(config: webHomeConfig): any {
  let banner: string;
  const Banners = [];
  for ((banner) in config.Banner) {
    if (config.Banner[banner]?.mobileHidden) {
      config.Banner[banner].class += '"desktop-only"';
    } else {
      // 去掉class里的desktop-only
      config.Banner[banner].class = config.Banner[banner].class?.replace('desktop-only', '');
    }
    if (banner === 'bannerB' || banner === 'bannerA') {
      config.Banner[banner].class += ' sf-banner--mobile-size';
    }
    let descriptionStyle = 'white-space:normal;';
    if (config.Banner[banner]?.descriptionSize) {
      descriptionStyle += 'font-size:' + config.Banner[banner].descriptionSize;
    }
    if (config.Banner[banner]?.descriptionColor) {
      descriptionStyle += ';color:' + config.Banner[banner].descriptionColor;
    }
    if (config.Banner[banner]?.descriptionWeight) {
      descriptionStyle += ';font-weight:' + config.Banner[banner].descriptionWeight;
    }
    let titleStyle = 'white-space:normal;';
    if (config.Banner[banner]?.titleSize) {
      titleStyle += 'font-size:' + config.Banner[banner].titleSize;
    }
    if (config.Banner[banner]?.titleColor) {
      titleStyle += ';color:' + config.Banner[banner].titleColor;
    }
    if (config.Banner[banner]?.titleWeight) {
      titleStyle += ';font-weight:' + config.Banner[banner].titleWeight;
    }
    let subTitleStyle = '';
    if (config.Banner[banner]?.subtitleSize) {
      subTitleStyle += 'font-size:' + config.Banner[banner].subtitleSize;
    }
    if (config.Banner[banner]?.subtitleColor) {
      subTitleStyle += ';color:' + config.Banner[banner].subtitleColor;
    }
    if (config.Banner[banner]?.subtitleWeight) {
      subTitleStyle += ';font-weight:' + config.Banner[banner].subtitleWeight;
    }
    if (config.Banner[banner].link === '') {
      config.Banner[banner].link = '/';
    }
    if (config.Banner[banner].image && typeof config.Banner[banner].image === 'string' || (typeof config.Banner[banner].image === 'object' && (config.Banner[banner].image?.desktop || config.Banner[banner].image?.mobile)) ) {
      Banners.push(
        {
          slot: config.Banner[banner].slot,
          subtitle: config.Banner[banner].subtitle,
          title: config.Banner[banner].title,
          description: config.Banner[banner].description,
          buttonText: config.Banner[banner]?.buttonText || '',
          class: config.Banner[banner].class,
          link: config.Banner[banner].link,
          image: config.Banner[banner].image,
          descriptionStyle: descriptionStyle,
          titleStyle: titleStyle,
          subTitleStyle: subTitleStyle
        }
      );
    }
    
  }
  return Banners;
}
function getMobileBanners(config: webHomeConfig): any {
  let banner: string;
  const Banners = [];
  for ((banner) in config.Banner) {
    if (config.Banner[banner]?.mobileHidden) {
      config.Banner[banner].class += '"desktop-only"';
    } else {
      // 去掉class里的desktop-only
      config.Banner[banner].class = config.Banner[banner].class?.replace('desktop-only', '');
    }
    if (banner === 'bannerB' || banner === 'bannerA') {
      config.Banner[banner].class += ' sf-banner--mobile-size';
    }
    let descriptionStyle = 'white-space:normal;';
    if (config.Banner[banner]?.mobileDescriptionSize) {
      descriptionStyle += 'font-size:' + config.Banner[banner].mobileDescriptionSize;
    }
    if (config.Banner[banner]?.mobileDescriptionColor) {
      descriptionStyle += ';color:' + config.Banner[banner].mobileDescriptionColor;
    }
    if (config.Banner[banner]?.mobileDescriptionWeight) {
      descriptionStyle += ';font-weight:' + config.Banner[banner].mobileDescriptionWeight;
    }
    let titleStyle = 'white-space:normal;';
    if (config.Banner[banner]?.mobileTitleSize) {
      titleStyle += 'font-size:' + config.Banner[banner].mobileTitleSize;
    }
    if (config.Banner[banner]?.mobileTitleColor) {
      titleStyle += ';color:' + config.Banner[banner].mobileTitleColor;
    }
    if (config.Banner[banner]?.mobileTitleWeight) {
      titleStyle += ';font-weight:' + config.Banner[banner].mobileTitleWeight;
    }
    let subTitleStyle = '';
    if (config.Banner[banner]?.mobileSubtitleSize) {
      subTitleStyle += 'font-size:' + config.Banner[banner].mobileSubtitleSize;
    }
    if (config.Banner[banner]?.mobileSubtitleColor) {
      subTitleStyle += ';color:' + config.Banner[banner].mobileSubtitleColor;
    }
    if (config.Banner[banner]?.mobileSubtitleWeight) {
      subTitleStyle += ';font-weight:' + config.Banner[banner].mobileSubtitleWeight;
    }
    config.Banner[banner].style = 'background-position: center;background-size: contain;';
    if (config.Banner[banner].image && typeof config.Banner[banner].image === 'string' || (typeof config.Banner[banner].image === 'object' && (config.Banner[banner].image?.desktop || config.Banner[banner].image?.mobile)) ) {
      Banners.push(
        {
          slot: config.Banner[banner].slot,
          subtitle: config.Banner[banner].subtitle,
          title: config.Banner[banner].title,
          description: config.Banner[banner].description,
          buttonText: config.Banner[banner]?.buttonText || '',
          class: config.Banner[banner].class,
          link: config.Banner[banner].link,
          image: config.Banner[banner].image,
          descriptionStyle: descriptionStyle,
          titleStyle: titleStyle,
          subTitleStyle: subTitleStyle,
          style: config.Banner[banner]?.style
        }
      );
    }
    
  }
  return Banners;
}
function getBanners(config: webHomeConfig, isMobile: boolean): any {
  const Banners = [];
  if (!config || !config.Banner) {
    return Banners;
  }
  if (isMobile) {
    return getMobileBanners(config);
  } else {
    return getDeskBanners(config);
  }
}
function getDeskHeroes(config: webHomeConfig): any {
  const Heroes = [];
  let index: any;
  for (index in config.Rotations) {
    let titleStyle = '';
    if (config.Rotations[index]?.titleSize) {
      titleStyle += 'font-size:' + config.Rotations[index].titleSize;
    }
    if (config.Rotations[index]?.titleColor) {
      titleStyle += ';color:' + config.Rotations[index].titleColor;
    }
    if (config.Rotations[index]?.titleWeight) {
      titleStyle += ';font-weight:' + config.Rotations[index].titleWeight;
    }
    let subTitleStyle = '';
    if (config.Rotations[index]?.subtitleSize) {
      subTitleStyle += 'font-size:' + config.Rotations[index].subtitleSize;
    }
    if (config.Rotations[index]?.subtitleColor) {
      subTitleStyle += ';color:' + config.Rotations[index].subtitleColor;
    }
    if (config.Rotations[index]?.subtitleWeight) {
      subTitleStyle += ';font-weight:' + config.Rotations[index].subtitleWeight;
    }
    // config.Rotations[index].link去除空格
    if (config.Rotations[index].link?.trim() === '') {
      config.Rotations[index].link = '';
    }
    config.Rotations[index].titleStyle = titleStyle;
    config.Rotations[index].subTitleStyle = subTitleStyle;
    if (index === 0) {
      config.Rotations[index].background = '#eceff1';
      config.Rotations[index].clasName = '';
    } else if (index === 1) {
      config.Rotations[index].background = '#efebe9';
      config.Rotations[index].clasName = 'sf-hero-item--position-bg-top-left sf-hero-item--align-right';
    } else if (index === 2) {
      config.Rotations[index].background = '#fce4ec';
      config.Rotations[index].clasName = '';
    }
    if (!config.Rotations[index].buttonText && config.Rotations[index].link && config.Rotations[index].link !== '/') {
      config.Rotations[index].className += ' heroDesktop';
    }
    if (config.Rotations[index].image) {
      Heroes.push(
        config.Rotations[index]
      );
    }
  }
  return Heroes;
}
function getMobileHeroes(config: webHomeConfig): any {
  const Heroes = [];
  let index: any;
  for (index in config.Rotations) {
    let titleStyle = '';
    if (config.Rotations[index]?.mobileTitleSize) {
      titleStyle += 'font-size:' + config.Rotations[index].mobileTitleSize;
    }
    if (config.Rotations[index]?.mobileTitleColor) {
      titleStyle += ';color:' + config.Rotations[index].mobileTitleColor;
    }
    if (config.Rotations[index]?.mobileTitleWeight) {
      titleStyle += ';font-weight:' + config.Rotations[index].mobileTitleWeight;
    }
    let subTitleStyle = '';
    if (config.Rotations[index]?.mobileSubtitleSize) {
      subTitleStyle += 'font-size:' + config.Rotations[index].mobileSubtitleSize;
    }
    if (config.Rotations[index]?.mobileSubtitleColor) {
      subTitleStyle += ';color:' + config.Rotations[index].mobileSubtitleColor;
    }
    if (config.Rotations[index]?.mobileSubtitleWeight) {
      subTitleStyle += ';font-weight:' + config.Rotations[index].mobileSubtitleWeight;
    }
    if (config.Rotations[index] === '') {
      config.Rotations[index].link = '/';
    }
    config.Rotations[index].titleStyle = titleStyle;
    config.Rotations[index].subTitleStyle = subTitleStyle;
    if (index === 0) {
      config.Rotations[index].background = '#eceff1';
      config.Rotations[index].clasName = '';
    } else if (index === 1) {
      config.Rotations[index].background = '#efebe9';
      config.Rotations[index].clasName = 'sf-hero-item--position-bg-top-left sf-hero-item--align-right';
    } else if (index === 2) {
      config.Rotations[index].background = '#fce4ec';
      config.Rotations[index].clasName = '';
    }
    if (config.Rotations[index].image) {
      Heroes.push(
        config.Rotations[index]
      );
    }
  }
  return Heroes;
}
function getHeroes(config: webHomeConfig, isMobile: boolean): any {
  const Heroes = [];
  if (!config || config?.Rotations?.length === 0) {
    return Heroes;
  }
  if (isMobile) {
    return getMobileHeroes(config);
  } else {
    return getDeskHeroes(config);
  }
}
function getKatherina(config: webHomeConfig): any {
  const Katherina = {};
  if (config && config.Katherina) {
    let katherina: any;
    for (katherina in config.Katherina) {
      if (config.Katherina[katherina] && (config.Katherina[katherina].image || config.Katherina[katherina].mobileImage)) {
        Katherina[katherina] = (config.Katherina[katherina]);
      }
    }
  }
  return Katherina;
}
function getKatherinaTopBar(config: webHomeConfig): any {
  let title = '';
  if (config?.KatherinaTopBar) {
    title = config.KatherinaTopBar?.title;
  }
  return title;
}

function getButtonText(heroeItem: ConfigItem): any {
  let buttonText = '';
  if (heroeItem.buttonText) {
    buttonText = heroeItem.buttonText;
  } else {
    buttonText = '';
  }
  return buttonText;
}

function getSocial(config: Config): any {
  return config?.config?.Social;
}

export const configGetters: ConfigGetters = {
  getBanners,
  getHeroes,
  getKatherina,
  getKatherinaTopBar,
  getButtonText,
  getSocial
};
